import { FC, useState } from 'react';
import { MdAdd, MdRemove } from 'react-icons/md';
import { CounterProps, Styled } from './';

const Counter: FC<CounterProps> = ({
  initialValue = 0,
  onIncrement,
  onDecrement,
}) => {
  const [counter, setCounter] = useState(initialValue);
  const handleIncrement = () => {
    const newValue = counter + 1;
    setCounter(newValue);
    onIncrement(newValue);
  };
  const handleDecrement = () => {
    const newValue = counter - 1;
    if (newValue === 0) {
      return false;
    }
    setCounter(newValue);
    onDecrement(newValue);
  };
  return (
    <Styled.CounterContainer>
      <MdRemove onClick={handleDecrement} size="24px" />
      {counter}
      <MdAdd onClick={handleIncrement} size="24px" />
    </Styled.CounterContainer>
  );
};

export default Counter;
